/**
 * Utilidades del Simulador del laboratorio.
 * @author Claude Code (Alexandra Parra) <direccionit.siaco@repremundo.com.co>
 * @since 2026-10-26
 */

/** Dirección de MailHog del laboratorio (los correos de prueba quedan ahí) */
export const MAILHOG = "http://localhost:8025";

/**
 * Mensaje legible del error de una llamada (422 con errors.message, 404, sin conexión).
 * @param {object} error Error de RTK Query
 * @returns {string} Mensaje
 */
export const mensajeError = (error) => {
  const datos = error?.data ?? {};
  const texto = datos?.errors?.message || datos?.message || datos?.errors?.exception;
  if (texto) {
    return texto;
  }
  return error?.status === 404 ? "El simulador no existe en este ambiente." : "El paso no se pudo simular. Revisa el DO e intenta de nuevo.";
};

/**
 * Convierte la respuesta de una mutación en {tono, texto} para mostrar en la tarjeta del paso.
 * @param {object} respuesta Resultado de unwrap o el error capturado
 * @param {boolean} bien true si la llamada salió bien
 * @param {Function} resumen Texto a partir de los datos cuando salió bien
 * @returns {{tono: string, texto: string}} Resultado
 */
export const resultado = (respuesta, bien, resumen) =>
  bien ? { tono: "bien", texto: resumen(respuesta?.data ?? respuesta ?? {}) } : { tono: "mal", texto: mensajeError(respuesta) };

/**
 * Ejecuta una mutación y entrega su resultado ya traducido; avisa al panel para refrescar el «Qué pasó».
 * @param {Function} mutar Disparador de la mutación
 * @param {object} cuerpo Datos que se envían
 * @param {Function} resumen Texto cuando sale bien
 * @param {Function} alTerminar Recibe {tono, texto}
 * @returns {Promise<void>}
 */
export const ejecutar = async (mutar, cuerpo, resumen, alTerminar) => {
  try {
    const datos = await mutar(cuerpo).unwrap();
    alTerminar(resultado(datos, true, resumen));
  } catch (error) {
    alTerminar(resultado(error, false, resumen));
  }
};
